import { SharedService } from './shared.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, interval, Subscription } from 'rxjs';
import { AuthService } from './auth.service';
import { AppRoutes } from '../models/route-model';
import uiConstants from '../../app-constants/ui-constants';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private lastActivityTime: number = Date.now();
  private checkInactivityInterval = 1000 * 60; // Check every minute
  private inactivityTimeout = uiConstants.General.APP_INACTIVITY_TIMEOUT; // Timeout in milliseconds
  private activityEvents$: any;
  private intervalSubscription: Subscription | null = null;

  constructor(private router: Router, private authService: AuthService, private sharedService: SharedService) {
    const window = this.getWindow();
    const document = this.getDocument();

    if (window && document) {
      // Merge activity events like mousemove and keypress
      this.activityEvents$ = merge(
        fromEvent(window, 'mousemove'),
        fromEvent(window, 'keypress'),
        fromEvent(document, 'visibilitychange') // Monitor visibility changes
      );

      // Listen to user activity and update last activity time
      this.activityEvents$.subscribe(() => this.handleActivity());

      // Start inactivity checks when the user logs in
      this.sharedService.isLoginSessionActiveSubject.subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          this.startInactivityCheck();
        } else {
          this.stopInactivityCheck();
        }
      });
    }
  }

  private getWindow(): any {
    return typeof window !== 'undefined' ? window : null;
  }

  private getDocument(): any {
    return typeof document !== 'undefined' ? document : null;
  }

  private handleActivity(): void {
    console.log("ACTIVE")

    const document = this.getDocument();

    if (document && document.visibilityState === 'visible') {
      this.lastActivityTime = Date.now(); // Reset activity time only if tab is visible
    }
  }

  private startInactivityCheck(): void {
    console.log("START")

    this.stopInactivityCheck(); // Ensure no duplicate subscriptions
    this.lastActivityTime = Date.now(); // Reset last activity time
    this.intervalSubscription = interval(this.checkInactivityInterval).subscribe(() => {
      console.log("CHECK")

      const currentTime = Date.now();
      const timeSinceLastActivity = currentTime - this.lastActivityTime;

      if (timeSinceLastActivity >= this.inactivityTimeout) {
        this.logoutUser();
      }
    });
  }

  private stopInactivityCheck(): void {
    console.log("STOP")
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  private logoutUser(): void {
    // this.stopInactivityCheck(); // Stop inactivity checks on logout
    this.authService.logout();
    this.router.navigate([AppRoutes.route_startpage]);
  }
}